import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Skeleton,
  Space,
  message,
} from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import config from "../../../config";

const base_url = config.base_url;
function EditCoupon({
  originalData,
  open,
  onOk,
  onCancel,
  userId,
  setFilteredCouponsData,
  setCouponsData,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [discountType, setDiscountType] = useState();
  const [hasExpirationDate, setHasExpirationDate] = useState(false);
  const [theExpirationDate, setTheExpirationDate] = useState(null);
  const [couponStatus, setCouponStatus] = useState(null);
  const [couponExpirationDate, setCouponExpirationDate] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    messageApi.open({
      type: "success",
      content: "Coupon Edited Successfully",
    });
  };
  const initiatCouponData = () => {
    setLoading(true);
    let hasExpirationDate = 1;

    if (originalData.expiration_date) {
      setCouponExpirationDate(2);
      hasExpirationDate = 2;
      setHasExpirationDate(true);
    }

    console.log(originalData);

    form.setFieldsValue({
      coupon_code: originalData.code,
      coupon_what_customer_get: originalData.valueLabel,
      coupon_amount: originalData.value,
      coupon_expiration_date: hasExpirationDate,
      coupon_status: originalData.status,
      expiration_date_for_copoun: originalData.expiration_date
        ? dayjs(originalData.expiration_date)
        : dayjs(new Date().now),
    });
    setDiscountType(originalData.valueLabel);
    setLoading(false);
  };
  const editCoupon = () => {
    form
      .validateFields([
        "coupon_code",
        "coupon_what_customer_get",
        "coupon_amount",
        "expiration_date_for_copoun",
        "coupon_status",
      ])
      .then((res) => {
        const data = res;
        let expirationDate;
        if (data.expiration_date_for_copoun) {
          expirationDate = new Date(
            `${data.expiration_date_for_copoun.$d}`
          ).getTime();
        } else expirationDate = null;

        return fetch(base_url + "admin/partners/edit/coupon", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, /",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `coupon=${
            originalData.code
          }&expiration_date=${expirationDate}&partner_id=${userId}&customer_reward_percentage=${
            data.coupon_what_customer_get === "percentage"
              ? data.coupon_amount
              : ""
          }&customer_reward_amount=${
            data.coupon_what_customer_get === "amount" ? data.coupon_amount : ""
          }&customer_reward_time=${
            data.coupon_what_customer_get === "time"
              ? data.coupon_amount * 2629746000
              : ""
          }&valid=${data.coupon_status === "active" ? true : false}`,
        })
          .then((res) => res.json())
          .then((res) => {
            success();
            onOk();
            const data = res.data.map((user) => {
              const createdDay = new Date(user.created).getDate();
              const createdMonth = new Date(user.created).getMonth() + 1;
              const createdYear = new Date(user.created).getFullYear();
              let hasUsed = false;
              let usedDay;
              let usedMonth;
              let usedYear;
              let usedFormat;
              let hasExpiration = false;
              let expirationDay;
              let expirationMonth;
              let expirationYear;
              let expirationFormat;
              let value;
              let symbol;
              let valueLabel;

              if (user.customer_reward_amount !== null) {
                value = user.customer_reward_amount;
                symbol = "$";
                valueLabel = "amount";
              }
              if (user.customer_reward_percentage !== null) {
                value = user.customer_reward_percentage;
                symbol = "%";
                valueLabel = "percentage";
              }
              if (user.customer_reward_time !== null) {
                value = Math.round(user.customer_reward_time / 2629746000);
                symbol = "months";
                valueLabel = "time";
              }
              if (user.expiration_date) {
                hasExpiration = true;
                expirationDay = new Date(user.expiration_date).getDate();
                expirationMonth = new Date(user.expiration_date).getMonth() + 1;
                expirationYear = new Date(user.expiration_date).getFullYear();
                expirationFormat = `${expirationYear}-${expirationMonth}-${expirationDay}`;
              }
              if (user.used_date) {
                hasUsed = true;
                usedDay = new Date(user.created).getDate();
                usedMonth = new Date(user.created).getMonth() + 1;
                usedYear = new Date(user.created).getFullYear();
                usedFormat = `${usedYear}-${usedMonth}-${usedDay}`;
              }
              if (hasUsed && hasExpiration)
                return {
                  ...user,
                  used_date: usedFormat,
                  expiration_date: expirationFormat,
                  created: `${createdYear}-${createdMonth}-${createdDay}`,
                  value,
                  symbol,
                  valueLabel,
                };
              else if (hasUsed && !hasExpiration)
                return {
                  ...user,
                  used_date: usedFormat,
                  created: `${createdYear}-${createdMonth}-${createdDay}`,
                  value,
                  symbol,
                  valueLabel,
                };
              else if (!hasUsed && hasExpiration)
                return {
                  ...user,
                  expiration_date: expirationFormat,
                  created: `${createdYear}-${createdMonth}-${createdDay}`,
                  value,
                  symbol,
                  valueLabel,
                };
              else
                return {
                  ...user,
                  created: `${createdYear}-${createdMonth}-${createdDay}`,
                  value,
                  symbol,
                  valueLabel,
                };
            });
            // onOk();
            console.log(res);
            setCouponsData(data);
            setFilteredCouponsData(data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
  };
  return (
    <Modal
      footer={[
        <div
          style={{
            display: "flex",

            justifyContent: "flex-end",
          }}
        >
          <Button
            key={"cancel"}
            onClick={(e) => {
              onCancel();

              //   form.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            className="footerButtonSave"
            onClick={(e) => {
              editCoupon();
              //   form.resetFields();
            }}
            key={"submit"}
          >
            Save
          </Button>
        </div>,
      ]}
      afterOpenChange={(e) => {
        if (e === true) {
          initiatCouponData();
        }
      }}
      className="editCouponModal"
      open={open}
      onOk={onOk}
      onCancel={(e) => {
        onCancel();
        setLoading(true);
        setCouponExpirationDate(null);
        form.resetFields();
      }}
    >
      <h2>Edit A Single Coupon</h2>
      <Skeleton
        loading={loading}
        paragraph={{
          rows: 10,
        }}
      />
      {!loading && (
        <Form form={form}>
          {contextHolder}
          <Form.Item
            required
            className="formLabel"
            labelCol={{ span: 24 }}
            name={"coupon_code"}
            label="Coupon Code"
            rules={[
              {
                required: true,
                message: "Pleas enter valid coupon code",
              },
            ]}
          >
            <Input disabled style={{ width: "254px " }} className="formInput" />
          </Form.Item>

          <div className="editCouponSecodRow">
            <Form.Item
              style={{ width: "254px " }}
              required
              className="formLabel"
              labelCol={{ span: 24 }}
              name={"coupon_what_customer_get"}
              label="What the customer will get"
              rules={[
                {
                  required: true,
                  message: "Pleas choose one option",
                },
              ]}
            >
              <Select
                style={{ height: "46px" }}
                onChange={(e) => {
                  setDiscountType(e);
                }}
              >
                {/* <Select.Option value="amount">Discount</Select.Option> */}
                <Select.Option value="percentage">
                  Discount - percentage
                </Select.Option>
                <Select.Option value="time">
                  Free Subscription plan
                </Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              required
              className="formLabel"
              labelCol={{ span: 24 }}
              name={"coupon_amount"}
              label="Amount Per User"
              style={{
                width: "133px ",
              }}
              rules={[
                {
                  required: true,
                  message: "Pleas enter valid coupon amount",
                },
              ]}
            >
              {discountType === "amount" && (
                <InputNumber
                  addonBefore="$"
                  controls={false}
                  className="formInput"
                />
              )}
              {discountType === "percentage" && (
                <InputNumber
                  addonBefore="%"
                  controls={false}
                  className="formInput"
                />
              )}
              {discountType === "time" && (
                <InputNumber
                  addonAfter="months"
                  controls={false}
                  className="formInput"
                />
              )}
            </Form.Item>
          </div>
          <Form.Item
            style={{
              width: "200px",
            }}
            className="formLabel"
            labelCol={{ span: 24 }}
            name={"coupon_expiration_date"}
            label="Coupon expiration date"
            required
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Radio.Group
              onChange={(e) => {
                setCouponExpirationDate(e.target.value);
                e.target.value === 1 &&
                  form.setFieldsValue({
                    expiration_date_for_copoun: undefined,
                  });
              }}
            >
              <Space direction="vertical">
                <Radio value={1}>No expiration date</Radio>
                <Radio value={2}>Set expiration date: </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          {couponExpirationDate === 2 ? (
            <Form.Item
              style={{
                position: "absolute",
                top: "350px",
                left: "180px",

                width: "206px",
              }}
              name={"expiration_date_for_copoun"}
              rules={[
                {
                  required: true,
                  message: "choose a valid date",
                },
              ]}
            >
              <DatePicker
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
                style={{ width: "100%", height: "46px" }}
                onChange={(date, dateString) => {}}
              />
            </Form.Item>
          ) : (
            <></>
          )}
          <Form.Item
            style={{
              width: "380px",
            }}
            className="formLabel"
            labelCol={{ span: 24 }}
            name={"coupon_status"}
            label="Coupon Status"
            required
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              style={{
                width: "113px",
                height: "41px",
              }}
              onChange={(e) => setCouponStatus(e)}
            >
              <Select.Option value="active">Active</Select.Option>
              <Select.Option value="inactive">Inactive</Select.Option>
              <Select.Option value="expired">Expired</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
}

export default EditCoupon;
